import { Plugin } from 'ckeditor5';
import { OrcaPlaceholderSchema } from './OrcaPlaceholderSchema';
import { PlaceholderInteraction } from './interaction';
import { PlaceholderStore } from './store';
import { PlaceholderToolbar } from './toolbar';
import './style.css';
const PLACEHOLDER_CLASS = 'placeholders-enabled';
/**
 * This plugin adds support for rendering placeholders in the Orca editor.
 */
export class OrcaPlaceholders extends Plugin {
    static get pluginName() {
        return 'Placeholders';
    }
    static get requires() {
        return [PlaceholderStore, OrcaPlaceholderSchema, PlaceholderToolbar, PlaceholderInteraction];
    }
    /** Supplies the question list's label resolver. See `OrcaPlaceholderSchema`. */
    setRefResolver(resolver) {
        this.editor.plugins.get(OrcaPlaceholderSchema).setRefResolver(resolver);
    }
    /** Re-renders every placeholder chip after the question list changed. See `OrcaPlaceholderSchema`. */
    refreshLabels() {
        this.editor.plugins.get(OrcaPlaceholderSchema).refreshLabels();
    }
    init() {
        const { editor } = this;
        editor.editing.view.change((writer) => {
            const viewEditableRoot = editor.editing.view.document.getRoot();
            if (viewEditableRoot) {
                writer.setAttribute('class', PLACEHOLDER_CLASS, viewEditableRoot);
            }
        });
    }
}
